export default function MetricsSection() {
  return (
    <section className="w-full bg-background-100 px-10 md:px-16 lg:px-20 py-20 md:py-28" aria-labelledby="metrics-heading">
      {/* Top label */}
      <p className="font-heading text-xs italic text-foreground-400 tracking-wide mb-6">
        engineering excellence
      </p>

      {/* Main title */}
      <h2 id="metrics-heading" className="font-sans text-4xl md:text-5xl lg:text-[4.5rem] leading-[0.95] text-foreground-950 font-bold max-w-3xl">
        <span className="block">Built for</span>
        <span className="block">
          <em className="font-heading italic font-normal">long-term</em> quality
        </span>
        <span className="block">and reliability</span>
      </h2>

      {/* Subtitle */}
      <p className="mt-6 text-sm md:text-base text-foreground-500 font-body font-light max-w-lg leading-relaxed">
        Modern software engineering practices applied consistently across every stage of development.
      </p>

      {/* Two metric cards */}
      <div className="mt-14 md:mt-20 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left card - coral/terracotta */}
        <div className="bg-accent-400 rounded-lg p-10 md:p-12 lg:p-14 relative overflow-hidden min-h-[320px] flex flex-col justify-between">
          {/* Decorative circle */}
          <div className="absolute top-8 right-8 w-10 h-10 rounded-full border border-white/30 flex items-center justify-center" aria-hidden="true">
            <span className="w-4 h-[1px] bg-white/50 rotate-45"></span>
          </div>
          <div>
            <span className="font-heading text-6xl md:text-7xl lg:text-[5rem] text-background-50 font-bold leading-none">01</span>
          </div>
          <div>
            <p className="text-base md:text-lg text-background-50/90 font-body leading-relaxed max-w-sm">
              Clean architecture principles guide every project, ensuring systems remain maintainable and adaptable as requirements evolve.
            </p>
            <p className="mt-4 font-heading italic text-sm text-background-50/70">
              structured for longevity
            </p>
          </div>
        </div>

        {/* Right card - warm terracotta */}
        <div className="bg-accent-600 rounded-lg p-10 md:p-12 lg:p-14 relative overflow-hidden min-h-[320px] flex flex-col justify-between">
          {/* Decorative circle */}
          <div className="absolute top-8 right-8 w-10 h-10 rounded-full border border-white/25 flex items-center justify-center" aria-hidden="true">
            <span className="w-4 h-[1px] bg-white/40 rotate-45"></span>
          </div>
          <div>
            <span className="font-heading text-6xl md:text-7xl lg:text-[5rem] text-background-50 font-bold leading-none">02</span>
          </div>
          <div>
            <p className="text-base md:text-lg text-background-50/90 font-body leading-relaxed max-w-sm">
              Performance optimization is embedded in the development workflow, from initial design through deployment and ongoing maintenance.
            </p>
            <p className="mt-4 font-heading italic text-sm text-background-50/70">
              performance by design
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}